module.exports = __webpack_public_path__ + "static/media/Vortex-4WD-RV-5300.2d7eed89.png";